<div>
  <ng-container *ngFor="let invoice of invoices | slice:0:displayItemLength; let isLast = last;">
    <button
      andButton
      color="default"
      size="small"
      class="w-fit-content"
      [ngClass]="{ 'mb-1': !isLast }"
      data-cy="invoice-menu"
      [matMenuTriggerFor]="invoiceOptionsMenu"
      [disabled]="!invoice.invoiceFileId"
      [tooltip]="noInvoiceDetailsToolTip"
      [tooltipEnabled]="!invoice.invoiceFileId"
    >
      <span>{{ invoice.invoiceNumber }}</span>
    </button>
    <mat-menu #invoiceOptionsMenu="matMenu">
      <div>
        <button mat-menu-item (click)="previewInvoiceAsPdf(invoice.arTran.id)" data-cy="preview-invoice">
          Preview
        </button>
        <button
          mat-menu-item (click)="downloadInvoiceAsPdf(invoice.arTran.id, invoice.invoiceNumber)"
          data-cy="export-invoice"
        >
          Export
        </button>
      </div>
    </mat-menu>

    <ng-template #noInvoiceDetailsToolTip>
      <p class="text-center">
        Invoice not available for download.
      </p>
    </ng-template>
  </ng-container>

  <button
    *ngIf="invoices && invoices.length > displayItemLength"
    andButton
    color="ghost-secondary"
    size="small"
    class="w-fit-content"
    data-cy="expand-invoice-list"
    (click)="displayItemLength = invoices.length"
  >
    Show all invoices
  </button>
</div>
